import { SvgIconComponent } from '@mui/icons-material'
import { Breakpoint } from '@mui/material'
import { SvgIconProps } from '@mui/material/SvgIcon'

export type SidebarItem = {
  name: string
  label: string
  link: string
  icon: SvgIconComponent | ((props: SvgIconProps) => JSX.Element)
  isPathBase?: boolean
  badge?: number
}

export enum EstablishmentSubscription {
  ALL_ACCESS = 'ALL_ACCESS',
  EQUIP_ONLY = 'EQUIP_ONLY',
  TC_ONLY = 'TC_ONLY',
}

export enum SubscriptionType {
  PDS_ALL_ACCESS = 'PDS_ALL_ACCESS',
  MED_ALL_ACCESS = 'MED_ALL_ACCESS',
  MED_GUEST = 'MED_GUEST',
  MED_BASIC = 'MED_BASIC',
  ADMIN = 'ADMIN',
  SUPER_ADMIN = 'SUPER_ADMIN',
  CUSTOM = 'CUSTOM',
  NO_SUBSCRIPTION = 'NO_SUBSCRIPTION',
}

export type Subscription = {
  sidebar: SidebarType[]
  dashboard: PartialDashboard[]
  type: SubscriptionType
}

export type PopulatedSubscription = {
  sidebar: SidebarItem[]
  dashboard: DashboardItem[]
  type: SubscriptionType
}
// Sidebar utils

export enum SidebarType {
  AdminApiKeys = 'admin:api-keys',
  AdminAirtable = 'admin:airtable',
  AdminLicenses = 'admin:licenses',
  AdminGroups = 'admin:groups',
  AdminEstablishment = 'admin:establishment',
  AdminPolicies = 'admin:policies',
  AdminPlannings = 'admin:plannings',
  AdminStaffs = 'admin:staffs',
  AdminStatistics = 'admin:statistics',
  AdminPlugin = 'admin:plugin',
  AdminKnowledgeBase = 'admin:knowledge-base',
  Calendar = 'calendar',
  Consultations = 'consultations',
  Ethics = 'ethics',
  SuperAdminApiKeys = 'super-admin:api-keys',
  Emergency = 'emergency',
  EmergenciesMed = 'emergenciesMed',
  Expertises = 'expertises',
  Home = 'home',
  LocalConsultations = 'localConsultations',
  MeetingLinks = 'meetingLinks',
  Networks = 'networks',
  Onboarding = 'onboarding',
  Patients = 'patients',
  Staffs = 'staffs',
  ShiftMarketplace = 'shiftMarketplace',
  SuperAdminContracts = 'super-admin:contracts',
  SuperAdminHome = 'super-admin:home',
  SuperAdminLicenses = 'super-admin:licenses',
  SuperAdminMeetingLinks = 'super-admin:meetingLinks',
  SuperAdminPolicies = 'super-admin:policies',
  SuperAdminSettings = 'super-admin:settings',
  SuperAdminStatistics = 'super-admin:statistics',
  SuperAdminWaitingRooms = 'super-admin:waitingrooms',
  SuperAdminMedicalActs = 'super-admin:medical-acts',
  Reports = 'reports',
  WaitingRooms = 'waitingrooms',
  FormTemplates = 'form-templates',
  Chat = 'chat',
  MedConnectAgent = 'medconnect-agent',
  MedConnectAdminAgent = 'medconnect-admin-agent',
  EstablishmentAgenda = 'establishment-agenda',
  AdminMedicalActs = 'admin:medical-acts',
  AdminDesmosActs = 'admin:desmos-acts',
  AdminDataExport = 'admin:data-export',
  AdminTrustedActors = 'admin:trusted-actors',
  AdminInsWorklist = 'admin:ins-worklist',
  SuperAdminDataExport = 'super-admin:data-export',
  Tutorials = 'tutorials',
  TimeTracking = 'time-tracking',
}

export type DashboardConfig = {
  col: { [key in Breakpoint]?: number }
}

export enum PartialDashboard {
  Agenda = 'agenda',
  Consultations = 'consultations',
  ConsultationsStatistics = 'consultations-statistics',
  Equipments = 'equipments',
  ExamsStatistics = 'exams-statistics',
  ExpertiseAndConsultationsTab = 'expertise-and-consultations-tab',
  Expertises = 'expertises',
  LocalConsultation = 'local-consultation',
  MeetingLinksStatistics = 'meeting-links-statistics',
  Patients = 'patients',
  ShiftDashboard = 'shift-dashboard',
  FavoriteWaitingRooms = 'favorite-waiting-rooms',
  WaitingRoom = 'waiting-room',
  Welcome = 'welcome',
  EmergencyQuickAccess = 'emergency',
}

export type DashboardItem = {
  id: PartialDashboard
  config: DashboardConfig
  component: JSX.Element
}

export type DashboardItemList = Array<{
  label: PartialDashboard
  component: JSX.Element
  order: number
}>
